/*
 * Global startup base script.
 * Consolidated from inline <script> blocks previously in index.html.
 * - Suppresses React & Apollo devtools noisy console messages.
 * - Implements frame-busting & reveals <html> when not embedded.
 */

/* Devtools suppression stubs */
/* eslint-disable no-unused-vars */
const __REACT_DEVTOOLS_GLOBAL_HOOK__ = {
  supportsFiber: true,
  inject: function () {},
  onCommitFiberRoot: function () {},
  onCommitFiberUnmount: function () {}
};
const __APOLLO_DEVTOOLS_GLOBAL_HOOK__ = false;
/* eslint-enable no-unused-vars */

(function frameBustAndReveal(d) {
  if (self === top) {
    d.documentElement.style.display = 'block';
  } else {
    top.location = self.location; // See security notes (false positives previously documented)
  }
})(document);
